//import './sass/style.scss'; //using dart sass not webpack to compile sass - check package.json

//if global/window jquery needs to be exposed
//global.$ = $;

import $ from 'jquery';

//vendor files if NPM package isn't available
//import './vendor/slick';

//our files
import App from './app';

import Menu from './menu';

import Animations from './animations';

import { checkboxFilter as Multifilter } from './multifilter';

//import Multicheckfilter from './multicheckfilter';

import Sliders from './sliders';

//import Filters from './filters';

import Global from './global';
import Accordion from './Accordion';

import ScrollAnimation from './scroll-animation';

import AgeGateModal from './age-game-modal';

import ReviewsSection from './blocks/reviews';

import TestimonialsSection from './blocks/testimonials';

import BlogGridSection from './blocks/blog-grid';

import Dropdowns from './helpers/dropdowns';

//import ContactSection from './blocks/contact';

import IntroVSIconBlocks from './blocks/intro-block-vs-icon-block';

import Video from './video';

import PriceDisplay from './price-display';

import { eventDateFilter } from './multifilter';
$(() => {
  // Initialize global modules
  AgeGateModal.init();

  App.init();

  Menu.init();

  Animations.init();

  Multifilter.init();

  Accordion.init();

  //Multicheckfilter.init();
  Sliders.init();

  Global.init();

  //Filters.init();

  ScrollAnimation.init();

  ReviewsSection.init();

  TestimonialsSection.init();

  Dropdowns.init();

  BlogGridSection.init();

  //ContactSection.init();

  IntroVSIconBlocks.init();

  Video.init();

  PriceDisplay.init();
});
